interface TickIconProps {
    color?: string;
}

const TickIcon: React.FC<TickIconProps> = ({ color = "#22B060" }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 6.99997L9 19L3.5 13.5L4.91 12.09L9 16.17L19.59 5.58997L21 6.99997Z" fill={color} />
    </svg>
);
export default TickIcon;